import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { PhoneCall, ArrowRight } from 'lucide-react';
export function FinalCTA() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].finalCta;
  const containerRef = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: containerRef,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-80, 80]);
  return <section className="relative py-32 flex items-center justify-center overflow-hidden" ref={containerRef} data-id="element-142">
      {/* Background Image with Parallax */}
      <motion.div className="absolute inset-0 z-0" style={{
      y,
      scale: 1.1
    }} data-id="element-143">
        <img src="https://cdn.magicpatterns.com/uploads/kiRPZ67DCoPow89rjDSeY7/hf_20260430_172717_e667c99f-785e-4196-a80e-61f75430d1ed.png" alt="Happy Family Move" className="w-full h-full object-cover object-center" data-id="element-144" />
        {/* Vignette: dark on edges, image visible in center */}
        <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at center, rgba(33,33,33,0.3) 0%, rgba(33,33,33,0.7) 50%, rgba(33,33,33,0.95) 100%)'
      }} data-id="element-145"></div>
      </motion.div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 w-full text-center" data-id="element-146">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 20
      }} className="text-5xl md:text-7xl lg:text-8xl font-condensed font-black text-white uppercase tracking-tight mb-6 drop-shadow-[0_4px_20px_rgba(0,0,0,0.8)]" style={{
        textShadow: '0 4px 30px rgba(0,0,0,0.7)'
      }} data-id="element-147">
          {text.title}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl md:text-2xl text-gray-200 font-medium mb-12 max-w-2xl mx-auto" style={{
        textShadow: '0 2px 15px rgba(0,0,0,0.8)'
      }} data-id="element-148">
          {text.sub}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3,
        type: 'spring',
        stiffness: 100
      }} className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6" data-id="element-149">
          <a href="#booking" className="group relative flex items-center justify-center px-10 py-5 font-condensed font-bold text-2xl text-mf-black uppercase tracking-widest bg-mf-yellow rounded-2xl shadow-[0_8px_30px_rgba(255,193,7,0.4)] hover:shadow-[0_12px_40px_rgba(255,193,7,0.6)] transition-all duration-300 transform hover:-translate-y-1 overflow-hidden" data-id="element-150">
            <span className="relative z-10 flex items-center" data-id="element-151">
              {text.primaryBtn}
              <ArrowRight className="ml-3 group-hover:translate-x-2 transition-transform duration-300" size={28} data-id="element-152" />
            </span>
          </a>

          <a href="tel:+18134768935" className="flex items-center justify-center px-10 py-5 font-condensed font-bold text-2xl text-white uppercase tracking-widest bg-white/10 backdrop-blur-md border-2 border-white/40 hover:bg-white hover:text-mf-black hover:border-white rounded-2xl transition-all duration-300 transform hover:-translate-y-1" data-id="element-153">
            <PhoneCall className="mr-3" size={28} data-id="element-154" />
            {text.secondaryBtn}
          </a>
        </motion.div>
      </div>
    </section>;
}